export default __webpack_public_path__ + "static/image2-52141ec8383451b47fd17bf8d69186bb.jpeg";